module.exports = __webpack_public_path__ + "media/images/about-8677f8c4ca75ad913d959a2244ac285a.png";